"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _index = require("./common/index.cjs");
Object.keys(_index).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index[key];
    }
  });
});
var _BillingCycle = require("./BillingCycle.cjs");
Object.keys(_BillingCycle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BillingCycle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BillingCycle[key];
    }
  });
});
var _Campaign = require("./Campaign.cjs");
Object.keys(_Campaign).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Campaign[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Campaign[key];
    }
  });
});
var _Category = require("./Category.cjs");
Object.keys(_Category).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Category[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Category[key];
    }
  });
});
var _Contact = require("./Contact.cjs");
Object.keys(_Contact).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Contact[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Contact[key];
    }
  });
});
var _ContactDuplicateSuggestion = require("./ContactDuplicateSuggestion.cjs");
Object.keys(_ContactDuplicateSuggestion).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactDuplicateSuggestion[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactDuplicateSuggestion[key];
    }
  });
});
var _ContactTagGroup = require("./ContactTagGroup.cjs");
Object.keys(_ContactTagGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactTagGroup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactTagGroup[key];
    }
  });
});
var _ContactTag = require("./ContactTag.cjs");
Object.keys(_ContactTag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactTag[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactTag[key];
    }
  });
});
var _ContactsBulkSelector = require("./ContactsBulkSelector.cjs");
Object.keys(_ContactsBulkSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactsBulkSelector[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactsBulkSelector[key];
    }
  });
});
var _ContactsExport = require("./ContactsExport.cjs");
Object.keys(_ContactsExport).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactsExport[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactsExport[key];
    }
  });
});
var _ContactsScope = require("./ContactsScope.cjs");
Object.keys(_ContactsScope).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactsScope[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactsScope[key];
    }
  });
});
var _Country = require("./Country.cjs");
Object.keys(_Country).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Country[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Country[key];
    }
  });
});
var _CoverageEntry = require("./CoverageEntry.cjs");
Object.keys(_CoverageEntry).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CoverageEntry[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CoverageEntry[key];
    }
  });
});
var _CoverageIntegration = require("./CoverageIntegration.cjs");
Object.keys(_CoverageIntegration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CoverageIntegration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CoverageIntegration[key];
    }
  });
});
var _CoverageIntegrationRun = require("./CoverageIntegrationRun.cjs");
Object.keys(_CoverageIntegrationRun).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CoverageIntegrationRun[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CoverageIntegrationRun[key];
    }
  });
});
var _Culture = require("./Culture.cjs");
Object.keys(_Culture).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Culture[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Culture[key];
    }
  });
});
var _Currency = require("./Currency.cjs");
Object.keys(_Currency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Currency[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Currency[key];
    }
  });
});
var _DnsConfigurationInstruction = require("./DnsConfigurationInstruction.cjs");
Object.keys(_DnsConfigurationInstruction).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DnsConfigurationInstruction[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DnsConfigurationInstruction[key];
    }
  });
});
var _EmailRecipient = require("./EmailRecipient.cjs");
Object.keys(_EmailRecipient).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EmailRecipient[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EmailRecipient[key];
    }
  });
});
var _EmailSubscription = require("./EmailSubscription.cjs");
Object.keys(_EmailSubscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EmailSubscription[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EmailSubscription[key];
    }
  });
});
var _JobState = require("./JobState.cjs");
Object.keys(_JobState).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _JobState[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _JobState[key];
    }
  });
});
var _Language = require("./Language.cjs");
Object.keys(_Language).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Language[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Language[key];
    }
  });
});
var _License = require("./License.cjs");
Object.keys(_License).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _License[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _License[key];
    }
  });
});
var _Newsroom = require("./Newsroom.cjs");
Object.keys(_Newsroom).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Newsroom[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Newsroom[key];
    }
  });
});
var _NewsroomCompanyInformation = require("./NewsroomCompanyInformation.cjs");
Object.keys(_NewsroomCompanyInformation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewsroomCompanyInformation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NewsroomCompanyInformation[key];
    }
  });
});
var _NewsroomContact = require("./NewsroomContact.cjs");
Object.keys(_NewsroomContact).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewsroomContact[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NewsroomContact[key];
    }
  });
});
var _NewsroomDomain = require("./NewsroomDomain.cjs");
Object.keys(_NewsroomDomain).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewsroomDomain[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NewsroomDomain[key];
    }
  });
});
var _NewsroomGallery = require("./NewsroomGallery.cjs");
Object.keys(_NewsroomGallery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewsroomGallery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NewsroomGallery[key];
    }
  });
});
var _NewsroomLanguageSettings = require("./NewsroomLanguageSettings.cjs");
Object.keys(_NewsroomLanguageSettings).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewsroomLanguageSettings[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NewsroomLanguageSettings[key];
    }
  });
});
var _NewsroomSubscription = require("./NewsroomSubscription.cjs");
Object.keys(_NewsroomSubscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewsroomSubscription[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NewsroomSubscription[key];
    }
  });
});
var _NewsroomTheme = require("./NewsroomTheme.cjs");
Object.keys(_NewsroomTheme).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewsroomTheme[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NewsroomTheme[key];
    }
  });
});
var _NewsroomWebhook = require("./NewsroomWebhook.cjs");
Object.keys(_NewsroomWebhook).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewsroomWebhook[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NewsroomWebhook[key];
    }
  });
});
var _Plan = require("./Plan.cjs");
Object.keys(_Plan).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Plan[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Plan[key];
    }
  });
});
var _Price = require("./Price.cjs");
Object.keys(_Price).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Price[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Price[key];
    }
  });
});
var _PrivacyRequest = require("./PrivacyRequest.cjs");
Object.keys(_PrivacyRequest).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PrivacyRequest[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PrivacyRequest[key];
    }
  });
});
var _SenderAddress = require("./SenderAddress.cjs");
Object.keys(_SenderAddress).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SenderAddress[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SenderAddress[key];
    }
  });
});
var _SenderDomain = require("./SenderDomain.cjs");
Object.keys(_SenderDomain).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SenderDomain[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SenderDomain[key];
    }
  });
});
var _Snippet = require("./Snippet.cjs");
Object.keys(_Snippet).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Snippet[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Snippet[key];
    }
  });
});
var _SortOrder = require("./SortOrder.cjs");
Object.keys(_SortOrder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SortOrder[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SortOrder[key];
    }
  });
});
var _Story = require("./Story.cjs");
Object.keys(_Story).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Story[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Story[key];
    }
  });
});
var _User = require("./User.cjs");
Object.keys(_User).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _User[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _User[key];
    }
  });
});
var _UserAccount = require("./UserAccount.cjs");
Object.keys(_UserAccount).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserAccount[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _UserAccount[key];
    }
  });
});
var _NotificationSubscription = require("./NotificationSubscription.cjs");
Object.keys(_NotificationSubscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NotificationSubscription[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NotificationSubscription[key];
    }
  });
});